<template>
  <div class="webinar">
    <toggleSwitch
      :value="webinar"
      :title="$t('settings.webinar.title')"
      :help="$t('settings.webinar.info')"
      :callback="setWebinar"
    />
    <div v-if="webinar" class="flix-form-group" style="margin-left: 35px">
      <h4 style="margin-bottom: 10px">
        {{ $t("settings.webinar.system.title") }}
      </h4>
      <div class="flix-flex flix-flex-inline flix-flex-center flix-gap-5">
        <icon id="circle-selected" class="icon" /> {{ system.bookingflix }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      webinar: this.getWebinar(),
      system: { bookingflix: this.$t("settings.webinar.system.bookingflix") }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    setWebinar() {
      this.webinar = !this.webinar;
      this.setSave();
    },
    getWebinar() {
      if (
        typeof this.$store.state.business.unsaved.webinar === "undefined" ||
        !this.$store.state.business.unsaved.webinar
      ) {
        return false;
      } else {
        return true;
      }
    },
    setSave() {
      var data = JSON.parse(JSON.stringify(this.$store.state.business.unsaved));
      if (typeof data.webinar === "undefined" || !data.webinar) {
        data.webinar = Object.keys(this.system)[0];
      } else {
        data.webinar = false;
      }
      this.$store.commit("business/prefetch", data);
    }
  }
};
</script>
<style lang="sass" scoped>
@import '@/assets/sass/variables.sass'
.icon
  color: $success
  font-size: 16pt
</style>
